import React from 'react'
import { Badge, Nav } from 'react-bootstrap'
import { Link } from 'react-router-dom';

const NavLink = ({
    to,
    children,
    active,
    badge
}) => {
    return (
        <Nav.Item>
            {badge && <Badge
                pill
                variant='danger'
                style={{
                    position: 'absolute',
                    float: 'right',
                    marginLeft: '80px',
                    marginTop: '-7px',
                    zIndex: 100
                }}
            >
                &nbsp;
            </Badge>}
            <Nav.Link style={{ padding: '0px' }} as={Link} to={to} eventKey={to} active={active}>{children}</Nav.Link>
        </Nav.Item>
    )
}

export default NavLink